import { Dispatch, SetStateAction } from "react";
import { Modal, Button, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useAddFAQMutation, useUpdateFaqMutation } from "../services/cms";

interface ModalProps {
    open: boolean;
    activeId: string;
    title: string;
    description: string;
    onClose: () => void;
    onSuccess: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

const FaqSchema = Yup.object().shape({
    question: Yup.string().required("Question is required"),
    answer: Yup.string().required("Answer is required"),
});

export default function AddFaq({ open, activeId, title, description, onClose, setOpen, onSuccess }: ModalProps) {
    const [submitFaq] = useAddFAQMutation();
    const [updateFaq] = useUpdateFaqMutation();

    const handleFaq = async (body: { question: string; answer: string }, resetForm: any) => {
        try {
            let response = {} as any;
            if (!!activeId?.length) {
                response = await updateFaq({ body: { ...body, id: activeId } } as any).unwrap();
            } else {
                response = await submitFaq({ body: body as any }).unwrap();
            }
            if (response?.statusCode == 200) {
                setOpen(false);
                resetForm();
                onSuccess();
            }
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <Modal
            className="modal addNotification_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>{`${!!activeId?.length ? 'Edit' : 'Add'} FAQ`}</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    <Formik
                        initialValues={{ question: title || "", answer: description || "" }}
                        validationSchema={FaqSchema}
                        onSubmit={async (values, { resetForm }) => {
                            const body = {
                                question: values.question,
                                answer: values.answer,
                            };
                            handleFaq(body, resetForm);
                        }}
                    >
                        {({ errors, touched }) => (
                            <Form className="form">
                                <div className="control_group">
                                    <Field
                                        as={TextField}
                                        name="question"
                                        placeholder="Question"
                                        fullWidth
                                        hiddenLabel
                                    />
                                    {errors.question && touched.question && (
                                        <h6 className="err_msg">{errors.question}</h6>
                                    )}
                                </div>

                                <div className="control_group">
                                    <Field
                                        as={TextField}
                                        name="answer"
                                        placeholder="Answer"
                                        fullWidth
                                        hiddenLabel
                                        multiline
                                        minRows={5}
                                        maxRows={5}
                                    />
                                    {errors.answer && touched.answer && (
                                        <h6 className="err_msg">{errors.answer}</h6>
                                    )}
                                </div>

                                <div className="footer_btn_flex">
                                    <Button
                                        className="btn btn_grey"
                                        type="button"
                                        onClick={onClose}
                                    >
                                        Cancel
                                    </Button>
                                    <Button className="btn btn_primary" type="submit">
                                        Submit
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </Modal>
    );
}